import { useState } from "react";
import Link from "next/link";
import { stepItems } from "./utils";
import routes from "@/constants/routes";
import RightArrow from "@/public/icons/hiw-right-arrow.svg";
import TimeClock from "@/public/icons/clock-orange-circle.svg";
import Step4Image from "@/public/icons/hiw-step4.svg";
import ExpandableBox from "@/components/landing-old/ExpandableBox";

const Step4 = (): JSX.Element => {
  const [activeIndex, setActiveIndex] = useState(-1);

  const clickHandler = (idx: number) => {
    setActiveIndex((current) => (current === idx ? -1 : idx));
  };

  return (
    <section className="relative bg-white w-full px-4 md:px-5 lg:px-20 lg:py-16">
      <div className="h-20 lg:h-0"></div>
      <h2 className="flex lg:hidden text-landing-orange font-bold text-2xl lg:text-3xl mb-3 lg:mb-5">
        Step 4
      </h2>
      <div className="flex flex-col lg:flex-row items-center lg:items-start">
        <div className="hidden lg:flex  lg:justify-around lg:w-1/2 mr-5">
          <Step4Image width={"80%"} height={"100%"} />
        </div>
        <div className="flex flex-col lg:w-1/2 lg:mr-20">
          <h2 className="hidden lg:flex text-landing-orange font-bold text-2xl lg:text-3xl mb-3 lg:mb-5">
            Step 4
          </h2>
          <h3 className="text-4xl lg:text-5xl font-bold text-landing-blue mb-5 md:mb-3 lg:mb-5">
            Move in and start saving
          </h3>
          <div className="flex flex-col md:flex-row lg:flex-col items-center">
            <div className="w-full md:w-1/2 lg:w-full">
              <h4 className="font-serif text-xl lg:text-3xl text-landing-blue mb-5">
                Treat the home like your own and start working towards owning it.
              </h4>
              <p className="font-base mb-5">
                Time to move into your new home. You will sign your rental and future buyback agreements and first
                month’s rent and the keys are in your hand. Time to start saving for a deposit.
              </p>
              <p className="font-base mb-4 md:mb-12 lg:mb-9">
                Your monthly payments are locked. No increases! Your future buy-back price is also
                provided ahead of time - we give you with the support to work on your deposit and
                mortgage-ready.
              </p>
            </div>
            <div className="md:w-1/2 hidden md:flex justify-around lg:hidden">
              <Step4Image width={"90%"} height={"100%"} />
            </div>
          </div>
          <div className="flex flex-row justify-between mb-0 md:mb-6 lg:mb-9">
            <a className="relative flex items-center" href={routes.faqs}>
              <span className={`relative text-base font-bold text-landing-orange`}>More FAQs</span>
              <RightArrow className="md:ml-3 ml-1" />
            </a>
            <div className="flex flex-row justify-between items-center">
              <TimeClock className="mr-3" />
              <span className={`inline-block relative text-base text-landing-orange`}>1 day!</span>
            </div>
          </div>
          <div className="md:hidden w-full my-5 flex justify-around">
            <Step4Image width={"80%"} height={"100%"} />
          </div>
          <div className="relative z-30 w-full">
            {stepItems.map((faq, idx) => (
              <div key={idx}>
                <ExpandableBox
                  question={faq.question}
                  answer={faq.answer}
                  active={activeIndex === idx}
                  clickHandler={() => clickHandler(idx)}
                  page={"hiw"}
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Step4;
